'use strict';

import { $, block, unblock, nonces, ajaxUrl } from '../globals.js';

const request = function ( method, action, security, params, args ) {
		if ( ! request?.activeRequests ) {
			request.activeRequests = {};
		}

		// retrieve wrapper as current context.
		const $wrapper = $( this );

		if ( params instanceof FormData ) {
			params.append( 'action', `yith_stripe_payments_${ action }` );
			params.append(
				'security',
				nonces?.[ security ] ? nonces?.[ security ] : security
			);
		} else {
			params = {
				action: `yith_stripe_payments_${ action }`,
				security: nonces?.[ security ]
					? nonces?.[ security ]
					: security,
				...params,
			};
		}

		const requestKey = `${ method }-${ action }`;

		const ajaxArgs = {
			url: ajaxUrl,
			data: params,
			method,
			beforeSend: () => $wrapper.length && block( $wrapper ),
			complete: () => $wrapper.length && unblock( $wrapper ),
			...args,
		};

		// eslint-disable-next-line
		if ( request?.activeRequests[ requestKey ] && typeof request.activeRequests[ requestKey ]?.abort === 'function' ) {
			request.activeRequests[ requestKey ].abort();
		}

		const xhr = $.ajax( ajaxArgs );
		request.activeRequests[ requestKey ] = xhr;

		xhr.always( () => delete request.activeRequests[ requestKey ] );

		return xhr;
	},
	get = function ( ...params ) {
		return request.call( this, 'get', ...params );
	},
	post = function ( ...params ) {
		return request.call( this, 'post', ...params );
	};

export default { request, get, post };
